// /* eslint-disable @typescript-eslint/no-explicit-any */
// import StyleOrderUpdatedComponent from "@/components/StyleOrderUpdated";
// import { useEffect, useState } from "react";
// import { useGeneralApiCall } from "@/services/useGeneralApiCall";
// import FetchDataWithLoader from "@/components/InfinityLoading";
// import InfiniteScroll from "react-infinite-scroll-component";
// import { Alert } from "react-bootstrap";
// import { showToast } from "@/api/notification";

// function ArchiveStyle() {
//   const { getApi, postApi, error } = useGeneralApiCall();
//   const [page, setPage] = useState(1);
//   const [items, setItems] = useState<any[]>([]);
//   const [nextapi, setnextapi] = useState("");
//   const [hasMore] = useState(true);
//   const [isLoading, setIsLoading] = useState(false);

//   const getData = async (come: boolean) => {
//     let response: any;
//     if (come) {
//       response = await getApi("api/style/v1/offsite-styles/");
//       const data: any = response.data;
//       setItems([...data.results]);
//       return;
//     } else if (hasMore && !nextapi) {
//       response = await getApi("api/style/v1/offsite-styles/");
//     } else {
//       response = await getApi(`api/style/v1/style/${nextapi}`);
//       setnextapi("");
//     }
//     const data: any = response.data;
//     setnextapi(data.next === null ? "" : data.next);
//     setItems([...items, ...response.data.results]);

//     setItems([...items, ...data.results]);
//   };

//   useEffect(() => {
//     getData(false);
//   }, []);

//   const handlePostApi = async (images: any) => {
//     setnextapi("");
//     setIsLoading(true);
//     try {
//       const res = await postApi("api/style/v1/reorder-styles/", images);
//       if (res?.status === 200) {
//         // getData(true);
//         setItems([...(Array.isArray(res.data) ? res.data : [])]);
//         showToast({ message: "Updated Successfully", type: "success" });
//       }
//     } catch (error) {
//       console.log(error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const loadMore = () => {
//     setPage(page + 1);
//     if (hasMore) {
//       getData(false);
//     }
//   };

//   return (
//     <>
//       {error ? (
//         <Alert variant="danger" className="text-center">
//           {error}
//         </Alert>
//       ) : (
//         <InfiniteScroll
//           dataLength={items?.length}
//           next={loadMore}
//           hasMore={hasMore}
//           loader={<FetchDataWithLoader />}
//           endMessage={
//             <Alert variant="info" className="text-center">
//               No more styles to load
//             </Alert>
//           }
//         >
//           <StyleOrderUpdatedComponent
//             initialImagesTemp={items}
//             path="/style/details"
//             title="STYLE ORDER MANAGEMENT"
//             handlePostApi={handlePostApi}
//             isLoading={isLoading}
//           />
//         </InfiniteScroll>
//       )}
//     </>
//   );
// }

// export default ArchiveStyle;

/* eslint-disable @typescript-eslint/no-explicit-any */

import StyleOrderUpdatedComponent from "@/components/StyleOrderUpdated";
import { useEffect, useState } from "react";
import { useGeneralApiCall } from "@/services/useGeneralApiCall";
import FetchDataWithLoader from "@/components/InfinityLoading";
import InfiniteScroll from "react-infinite-scroll-component";
import { Alert } from "react-bootstrap";
import { showToast } from "@/api/notification";

function ArchiveStyle() {
  const { getApi, postApi, error } = useGeneralApiCall();
  const [page, setPage] = useState(1);
  const [items, setItems] = useState<any[]>([]);
  const [nextUrl, setNextUrl] = useState<string | null>(null);
  const [hasMore, setHasMore] = useState(true); // Now properly managed
  const [isLoading, setIsLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true); // For first load

  console.log(page);
  const getData = async (isRefresh: boolean = false) => {
    try {
      setIsLoading(true);
      let response: any;

      if (isRefresh) {
        // Fresh data load
        response = await getApi("api/style/v1/offsite-styles/");
        const data: any = response.data;
        setItems(data.results || []);
        setNextUrl(data.next);
        setHasMore(!!data.next);
        setPage(1);
      } else {
        // Load more data
        if (!nextUrl) {
          setHasMore(false);
          return;
        }

        // Extract the endpoint from the full URL
        const urlParts = nextUrl.split("/api/");
        const endpoint = urlParts.length > 1 ? `api/${urlParts[1]}` : nextUrl;

        response = await getApi(endpoint);
        const data: any = response.data;

        // Append new items to existing ones
        setItems((prevItems) => [...prevItems, ...(data.results || [])]);
        setNextUrl(data.next);
        setHasMore(!!data.next);
        setPage((prevPage) => prevPage + 1);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setHasMore(false);
    } finally {
      setIsLoading(false);
      setInitialLoading(false);
    }
  };

  useEffect(() => {
    getData(true); // Initial load with refresh
  }, []);

  const handlePostApi = async (images: any) => {
    setIsLoading(true);
    try {
      const res = await postApi("api/style/v1/reorder-styles/", images);
      if (res?.status === 200) {
        // Refresh data after successful update
        await getData(true);
        showToast({ message: "Updated Successfully", type: "success" });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const loadMore = () => {
    if (hasMore && !isLoading) {
      getData(false);
    }
  };

  // Show loading for initial data fetch
  if (initialLoading) {
    return (
      <div className="text-center p-4">
        <FetchDataWithLoader />
      </div>
    );
  }

  // Show error state
  if (error) {
    return (
      <Alert variant="danger" className="text-center">
        {error}
      </Alert>
    );
  }

  // Show "no data found" when items array is empty and not loading
  if (!items || items.length === 0) {
    return (
      <Alert variant="info" className="text-center">
        <h4>No Styles Found</h4>
        <p>There are no styles available at the moment.</p>
      </Alert>
    );
  }

  return (
    <InfiniteScroll
      dataLength={items.length}
      next={loadMore}
      hasMore={hasMore}
      loader={<FetchDataWithLoader />}
      endMessage={
        <Alert variant="info" className="text-center">
          <h5>All styles loaded!</h5>
          <p>No more styles to display.</p>
        </Alert>
      }
    >
      <StyleOrderUpdatedComponent
        initialImagesTemp={items}
        path="/style/details"
        title="Archived style MANAGEMENT"
        handlePostApi={handlePostApi}
        isLoading={isLoading}
      />
    </InfiniteScroll>
  );
}

export default ArchiveStyle;
